import { render } from "./NotificationView.vue?vue&type=template&id=7927f762"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__